import React from 'react';
import './Cali.css'; 

const Cartagena = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKCG.pdf" target="_blank" rel="noreferrer">Aeropuerto Rafael Nuñez</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 01</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/IRAX2A.pdf" target="_blank" rel="noreferrer">IRAX2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/KOPG2A.pdf" target="_blank" rel="noreferrer">KOPG2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/BAQ3A.pdf" target="_blank" rel="noreferrer">BAQ3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/BAQ3A.pdf" target="_blank" rel="noreferrer">CTG2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/VARO2A.pdf" target="_blank" rel="noreferrer">VARO2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/ESKA2A.pdf" target="_blank" rel="noreferrer">ESKA2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/ESKA2A.pdf" target="_blank" rel="noreferrer">ILMI2A</a></th>
          </tr>
          

                
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 19</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/CTG2B.pdf" target="_blank" rel="noreferrer">CTG2B</a></th>
          </tr>

          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 01</th>                      
          </tr>
         <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">AKPA2A</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">BAQ4B</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">IRAX2B</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">KOPG2B</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">UBSU2A</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">UGRE3B</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">UGSA3A</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">UGSO2B</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2A.pdf" target="_blank" rel="noreferrer">VARO2B</a></th>
        </tr>
        
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 19</th>                      
          </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">AKPA2F</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">AKPA2E</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">BAQ3E</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">EDRE3D</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">IRAX2H</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">KOPG2D</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">UBSU2B</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">UGRE2C</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/AKPA2F.pdf" target="_blank" rel="noreferrer">UGSA2B</a></th>
        </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 01</th>                      
          </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/ILS01.pdf" target="_blank" rel="noreferrer">ILS</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/VOR01.pdf" target="_blank" rel="noreferrer">VOR</a></th>
        </tr>
        <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/RNP01.pdf" target="_blank" rel="noreferrer">RNP</a></th>
        </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 19</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCG/RNP19.pdf" target="_blank" rel="noreferrer">RNP</a></th>
        </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Cartagena;